"use client";

import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Sarah Johnson",
  position: "Founder & CEO",
  bio: "Sarah brings over 15 years of experience in project management and creative development, specializing in film and media.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/sarah_johnson_ceo.png"
}, {
  id: 2,
  name: "David Lee",
  position: "Film Development Specialist",
  bio: "David specializes in structuring film projects for funding and industry connections, with a background in production and finance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/david_lee_film_specialist.png"
}, {
  id: 3,
  name: "Maria Garcia",
  position: "Project Manager",
  bio: "Maria excels at coordinating complex projects, ensuring deadlines are met and operations run smoothly for all clients.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/maria_garcia_project_manager.png"
}, {
  id: 4,
  name: "James Chen",
  position: "Strategic Advisor",
  bio: "James provides strategic guidance to clients, helping them navigate challenges and achieve measurable growth.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/james_chen_strategic_advisor.png"
}, {
  id: 5,
  name: "Emily Rodriguez",
  position: "Creative Consultant",
  bio: "Emily works with filmmakers and creatives to develop compelling narratives and package projects for success.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/emily_rodriguez_creative_consultant.png"
}, {
  id: 6,
  name: "Michael Thompson",
  position: "Operations Director",
  bio: "Michael streamlines operational processes and implements systems that drive efficiency and client satisfaction.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/michael_thompson_operations_director.png"
}];
export default function LeadershipTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return;
}